export default __webpack_public_path__ + "static/media/about_arcane_0.42a00062.jpg";